// extracted by mini-css-extract-plugin
export default {"mobileSearchWrapper":"mobile-product-search_mobileSearchWrapper__U7leA","publishDate":"mobile-product-search_publishDate__Ddjte"};